if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        const ringSize = document.querySelector('[name="properties[ring_size]"]');
        if (ringSize && ringSize.required && !ringSize.value.trim()) {
          ringSize.reportValidity(); // shows the native browser bubble
          return;
        }
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const extraBtns = [...document.querySelectorAll('.extra-add.active:not([disabled])')];
        const hasExtras = extraBtns.length > 0;
        const is_apc_product = document.querySelector('.apc-product:checked');

        if (!hasExtras && !is_apc_product) {
          // ---- ORIGINAL PATH (no extras selected) ----
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => this._handleCartResponse(response, formData.get('id'), evt))
            .catch((e) => console.error(e))
            .finally(() => this._finallyHandler(evt));

        } else {
          // ---- BUNDLED PATH (main + all active extras in one request) ----
          const mainVariantId = this.variantIdInput.value;
          const mainQty = parseInt(this.form.querySelector('[name="quantity"]')?.value || 1);
          const sellingPlan = this.form.querySelector('[name="selling_plan"]')?.value || undefined;
          const bundle_id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

          /*const mainProperties = {};
          document.querySelectorAll(`[name^="properties"]`).forEach((el) => {
            const key = el.name.replace(/^properties\[(.+)\]$/, '$1');
            mainProperties[key] = el.value;
          });*/
          const mainProperties = {};
          document.querySelectorAll(`[name^="properties"]`).forEach((el) => {
            const key = el.name.replace(/^properties\[(.+)\]$/, '$1');

            // Skip radios/checkboxes that aren't selected
            if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) {
              return;
            }

            mainProperties[key] = el.value;
          });
          mainProperties['_bundle_id'] = bundle_id;

          let items = [
            {
              id: parseInt(mainVariantId),
              quantity: mainQty,
              ...(sellingPlan && { selling_plan: sellingPlan }),
              ...(Object.keys(mainProperties).length && { properties: mainProperties }),
            },
            ...extraBtns.map((btn) => ({
              id: parseInt(btn.dataset.id),
              quantity: 1,
              parent_id: parseInt(mainVariantId),
              properties: {
                _parent_variant_id: btn.dataset.parent,
                _bundle_id:bundle_id
              },
            })),
          ];
          if(is_apc_product){
            items.push({
              id: parseInt(is_apc_product.value),
              quantity: 1,
              parent_id: parseInt(mainVariantId),
              properties: {
                _parent_variant_id: is_apc_product.dataset.parent,
                 _bundle_id:bundle_id
              },
            })
          }

          const sections = this.cart ? this.cart.getSectionsToRender().map((s) => s.id) : [];
          if (this.cart) this.cart.setActiveElement(document.activeElement);

          fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              items,
              ...(sections.length && {
                sections,
                sections_url: window.location.pathname,
              }),
            }),
          })
            .then((response) => response.json())
            .then((response) => this._handleCartResponse(response, mainVariantId, evt))
            .catch((e) => console.error(e))
            .finally(() => this._finallyHandler(evt));
        }
      }

      _handleCartResponse(response, productVariantId, evt) {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId,
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });
        this.error = false;

        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                CartPerformance.measure('add:paint-updated-sections', () => {
                  this.cart.renderContents(response);
                });
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          CartPerformance.measure('add:paint-updated-sections', () => {
            this.cart.renderContents(response);
          });
        }
      }

      _finallyHandler(evt) {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
        CartPerformance.measureFromEvent('add:user-action', evt);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}